<template>
  <main>
    <LmFormBuilder
      :endpointUriwhereGetComponents="`formbuilder/${$route.params.idFormBuilder}`"
      :endpointUriWhereGetValuesToLoadInEditMode="fullEndpointUriToGetFormValues"
    />
  </main>
</template>

<script>
import commonsApi from '@/api/commons'
import LmFormBuilder from '@/components/LmFormBuilder'
export default {
  data () {
    return {
      apiRestForHandleAllHttpMethods: '',
      fullEndpointUriToGetFormValues: ''
    }
  },
  components: {
    LmFormBuilder
  },
  methods: {
    async getFormValues () {
      const endPoint = await commonsApi.axiosGetWrapper(`formbuilder/${this.$route.params.idFormBuilder}`)
      this.fullEndpointUriToGetFormValues = this.$route.params.id && endPoint.data.apiRestForHandleAllHttpMethods + this.$route.params.id
    }
  },
  watch: {
    '$route.params.idFormBuilder' () {
      this.getFormValues()
    }
  },
  created () {
    this.getFormValues()
  }
}
</script>
